export interface ISearchContext {
    id: string;
    display: string;
    filters: ISearchFilter[]
}

export interface ISearchFilter {
    id: number;
    display: string;
    lexeme: string;
    parameterType: IFilterParameterType
}

export interface IFilterParameterType {
    display: string;
    typeString: FilterParameterTypeString;
    regex: string;
};

export enum FilterParameterTypeString {
    String = 'System.String',
    Date = 'System.DateTime',
    Number = 'System.Int32'
}

export const ContextIds = Object.freeze({
    all: 'all',
    policy: 'Policy',
    publication: 'Publication',
    poc: 'Point-of-Care',
    shop: 'Shop',
    healthyChildren: 'Healthy Children',
    newsReleases: 'News Releases',
    advocacy: 'Advocacy',
    members: 'Members',
    grants: 'Grants',
    guidelines: 'Guidelines',
    education: 'Education',
    groups: 'Groups',
    resources: 'Resources',
    initiatives: 'Initiatives',
    programs: 'Programs',
    nicu: 'NICU',
    redBookOnline: 'Red Book Online'
});